module.exports = {
      id: "cinema-usage",
      viewBox: "0 0 26.501 25.377",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#cinema",
      toString: function () {
        return this.url;
      }
    }